import { HttpClient, HttpErrorResponse, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ResponseService, RevisionDTO } from '../types/type';
import { Utilerias } from '../helpers/Utilerias';
import { catchError, retry, throwError, zip } from 'rxjs';
import { UpdateRevisionDTO } from '../types/Entitys';

enum methods {
  GetRevisiones = 'GetRevisiones',
  GetNogocio = 'GetNogocio',
  GetCatalogoTipoRevisiones = 'GetCatalogoTipoRevisiones',
  SetRevision = 'SetRevision',
  DeleteRevision = 'DeleteRevision',
  UpdateObjetivoR = 'UpdateObjetivoR'
}

@Injectable({
  providedIn: 'root'
})
export class PlaneacionService {
  headers: HttpHeaders;
  URL: string

  constructor(private http: HttpClient) {
    this.URL = environment.urlService
    this.headers = new HttpHeaders();
    if (localStorage?.jwt) {
      this.headers = new HttpHeaders({
        'Authorization': localStorage.jwt
      })
    }
  }

  getRevisiones(IdEmpleado: number, page: number = 1) {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetRevisiones}?IdEmpleado=${IdEmpleado}&page=${page}`, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      )
  }
  getNegocio() {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetNogocio}`, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      )
  }
  getTipoRevisiones() {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetCatalogoTipoRevisiones}`, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      )
  }
  fetchLoadInit(IdEmpleado: number) {
    return zip(
      this.getRevisiones(IdEmpleado),
      this.getNegocio(),
      this.getTipoRevisiones()
    )
      .pipe(
        retry(3),
        catchError(this.handleError)
      )
  }
  nuevaRevision(revision: RevisionDTO) {
    return this.http.post<ResponseService>(`${this.URL}${methods.SetRevision}`, revision, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }
  eliminarRevision(idRevision: number) {
    return this.http.post<ResponseService>(`${this.URL}${methods.DeleteRevision}`, { idRevision }, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }
  actualizarRevision(revision: UpdateRevisionDTO) {
    return this.http.post<ResponseService>(`${this.URL}${methods.UpdateObjetivoR}`, revision, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  private handleError(error: HttpErrorResponse) {
    console.log('Error en Usuarios Service' + error.message);
    Utilerias.alertClient('Error al hacer la petición', 'Intente de nuevo', 1);
    if (error.status === HttpStatusCode.Unauthorized) {
      Utilerias.closeSesion(this.http);
      return throwError(() => new Error('!Error Unauthorized, verifique sus credenciales!'))
    }
    return throwError(() => new Error('!Fuera de servicio, intente nuevamente!'))
  }
}
